import React from 'react';

import AccordionSection from 'common/components/Accordion/AccordionSection';
import { SectionName } from './enums';
import LinkSectionList from './LinkSectionList';
import type { LinkSectionDataProps } from './types';

interface LinkSectionGroupProps {
  data: LinkSectionDataProps;
  isCollapsible: boolean;
  /** Method that checks if section should be open based on section name */
  isExpanded: boolean;
  /** Is the accordion behaviour active */
  isActive?: boolean;
  /** Are section items inline  */
  isInline?: boolean;
  /** Event callback for title click */
  onTitleClick: (sectionName: string) => void;
  /** Link section name */
  sectionName: string;
}

const LinkSectionGroup = ({
  data: { title, items },
  isExpanded,
  isCollapsible,
  isInline,
  onTitleClick,
  sectionName,
}: LinkSectionGroupProps) => {
  const hasBorderTop = sectionName === SectionName.General;

  return (
    <AccordionSection
      as="section"
      displayBorder={['block', null, 'none']}
      hasTopBorder={hasBorderTop}
      hasBottomBorder={!isInline}
      title={title}
      sectionName={sectionName}
      onTitleClick={onTitleClick}
      isCollapsible={isCollapsible}
      isExpanded={isExpanded}
      {...(isInline ? { displayTitle: 'none' } : {})}
    >
      <LinkSectionList items={items} isOpen={isExpanded} isInline={isInline} />
    </AccordionSection>
  );
};

export default LinkSectionGroup;
